export const KeyCodes = { To: 32, lo: 9, Eo: 13, _h: 27 };
